// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app{color:#303133;width:100%;max-width:1920px;margin:0 auto;box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
